import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import WorkFlowBlockCheckListServices from "./workflowblockchecklist.services";
import toastr from "toastr";
import { enviarCorreo } from "../capacitacion/actions";

export const getWorkflowBlockCheckLists =
  (filters, setData = null, type) =>
  async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_WORKFLOWBLOCK_CHECKLISTS,
        payload: true,
      });
      const resp =
        await WorkFlowBlockCheckListServices.getWorkFlowBlockCheckLists(
          filters,
          type
        );

      dispatch({
        type: actions.GET_WORKFLOWBLOCK_CHECKLISTS,
        payload: {
          workflowBlockCheckLists: resp.data.data,
          workflowBlockCheckListsLength: resp.data.count,
        },
      });

      if (setData) {
        setData(resp.data.data);
      }

      dispatch({
        type: actions.WORKFLOWBLOCK_CHECKLIST_FAIL,
        payload: "",
      });
      dispatch({
        type: actions.WORKFLOWBLOCK_CHECKLIST_FORM_FAIL,
        payload: null,
      });
    } catch (ex) {
      let message = "";
      if (axios.isAxiosError(ex)) {
        if (ex.response?.data) {
          message = ex.response.data.message;
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.WORKFLOWBLOCK_CHECKLIST_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_WORKFLOWBLOCK_CHECKLISTS,
        payload: false,
      });
    }
  };

export const getWorkflowBlockCheckList = (id, type) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_WORKFLOWBLOCK_CHECKLIST,
      payload: true,
    });
    const resp = await WorkFlowBlockCheckListServices.getWorkFlowBlockCheckList(
      id,
      type
    );
    dispatch({
      type: actions.GET_WORKFLOWBLOCK_CHECKLIST,
      payload: resp.data,
    });
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.data) {
        message = ex.response.data.message;
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.WORKFLOWBLOCK_CHECKLIST_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_WORKFLOWBLOCK_CHECKLIST,
      payload: false,
    });
  }
};

const handleFormErrors = (errors) => {
  let message = null;
  const {
    nombre,
    descripcion,
    fecha_inicio,
    fecha_fin,
    estado,
    posicion,
    bloque,
    archivo_bajar,
    calificacion,
    evaluable,
    subir_archivo,
    compa_guia,
    enlace_evaluacion,
  } = errors;
  if (nombre) {
    message = nombre;
  }
  if (descripcion) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...descripcion];
    } else {
      message = descripcion;
    }
  }
  if (fecha_inicio) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...fecha_inicio];
    } else {
      message = fecha_inicio;
    }
  }
  if (fecha_fin) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...fecha_fin];
    } else {
      message = fecha_fin;
    }
  }
  if (estado) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...estado];
    } else {
      message = estado;
    }
  }
  if (posicion) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...posicion];
    } else {
      message = posicion;
    }
  }
  if (bloque) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...bloque];
    } else {
      message = bloque;
    }
  }
  if (archivo_bajar) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...archivo_bajar];
    } else {
      message = archivo_bajar;
    }
  }
  if (calificacion) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...calificacion];
    } else {
      message = calificacion;
    }
  }
  if (evaluable) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...evaluable];
    } else {
      message = evaluable;
    }
  }
  if (subir_archivo) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...subir_archivo];
    } else {
      message = subir_archivo;
    }
  }
  if (compa_guia) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...compa_guia];
    } else {
      message = compa_guia;
    }
  }
  if (enlace_evaluacion) {
    if (typeof message === "object" && message !== null) {
      message = [...message, ...enlace_evaluacion];
    } else {
      message = enlace_evaluacion;
    }
  }
  return message;
};

export const saveWorkflowBlockCheckList =
  (data, workflowBlockCheckListsOptions = null, type) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_WORKFLOWBLOCK_CHECKLIST,
        payload: true,
      });
      const resp =
        await WorkFlowBlockCheckListServices.saveWorkFlowBlockCheckLists(
          data,
          type
        );
      if (type === 1) {
        await WorkFlowBlockCheckListServices.dateManage({
          tarea: resp.data.id,
        });
      }
      let oWorkflowBlockCheckLists = {
        workflowBlockCheckLists: [],
        workflowBlockCheckListsLength: 0,
      };
      const { workflowBlockCheckLists, workflowBlockCheckListsLength } =
        getState().workflowBlockCheckList;
      if (workflowBlockCheckListsOptions) {
        oWorkflowBlockCheckLists.workflowBlockCheckLists = [
          ...workflowBlockCheckListsOptions.data,
          resp.data,
        ];
      } else {
        oWorkflowBlockCheckLists.workflowBlockCheckLists = [
          ...workflowBlockCheckLists,
          resp.data,
        ];
      }
      oWorkflowBlockCheckLists.workflowBlockCheckListsLength =
        workflowBlockCheckListsLength + 1;
      dispatch({
        type: actions.GET_WORKFLOWBLOCK_CHECKLISTS,
        payload: {
          workflowBlockCheckLists:
            oWorkflowBlockCheckLists.workflowBlockCheckLists,
          workflowBlockCheckListsLength:
            oWorkflowBlockCheckLists.workflowBlockCheckListsLength,
        },
      });
      dispatch({
        type: actions.WORKFLOWBLOCK_CHECKLIST_FORM_FAIL,
        payload: null,
      });
      if (workflowBlockCheckListsOptions) {
        workflowBlockCheckListsOptions.setData(
          oWorkflowBlockCheckLists.workflowBlockCheckLists
        );
      }
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = handleFormErrors(ex.response.data);
              break;
            case 500:
              message = messages.errorMessage + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.WORKFLOWBLOCK_CHECKLIST_FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_WORKFLOWBLOCK_CHECKLIST,
        payload: false,
      });
    }
  };

export const estadoActividad =
  (data, index, type) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_WORKFLOWBLOCK_CHECKLIST,
        payload: true,
      });
      const { workflowBlockCheckLists, workflowBlockCheckListsLength } =
        getState().workflowBlockCheckList;
      if (type && type === 3) {
        await WorkFlowBlockCheckListServices.estadoActividadCierre(data);
        workflowBlockCheckLists[index].estado = false;
      } else {
        await WorkFlowBlockCheckListServices.estadoActividad(data, type);
        workflowBlockCheckLists[index].estado = true;
      }
      dispatch({
        type: actions.GET_WORKFLOWBLOCK_CHECKLISTS,
        payload: {
          workflowBlockCheckLists: workflowBlockCheckLists,
          workflowBlockCheckListsLength: workflowBlockCheckListsLength,
        },
      });
      toastr.success(messages.successMessage);
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              toastr.info("La tarea no puede ser actualizada");
              message = handleFormErrors(ex.response.data);
              break;
            case 500:
              message = messages.errorMessage + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.WORKFLOWBLOCK_CHECKLIST_FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_WORKFLOWBLOCK_CHECKLIST,
        payload: false,
      });
    }
  };

export const editWorkflowBlockCheckList =
  (
    data,
    id,
    workflowBlockCheckListsOptions,
    type,
    workflow_id,
    bloque_id,
    tarea_id,
    sameComp
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_WORKFLOWBLOCK_CHECKLIST,
        payload: true,
      });
      const resp = await WorkFlowBlockCheckListServices.editWorkFlowBlockCheckLists(
        id,
        data,
        type
      );
      if (type === 1) {
        await WorkFlowBlockCheckListServices.dateManage({
          tarea: id,
        });
      } else if (type === 2) {
        await WorkFlowBlockCheckListServices.dateManageWorkFlow({
          tarea: id,
        });
      }
      let oWorkflowBlockCheckLists = {
        workflowBlockCheckLists: [],
        workflowBlockCheckListsLength: 0,
      };

      const { workflowBlockCheckLists, workflowBlockCheckListsLength } =
        getState().workflowBlockCheckList;

      if (workflowBlockCheckListsOptions) {
        const ind = workflowBlockCheckListsOptions.data.findIndex(
          (item) => item.id === id
        );
        workflowBlockCheckListsOptions.data[ind] = resp.data;
        oWorkflowBlockCheckLists.workflowBlockCheckLists =
          workflowBlockCheckListsOptions.data;
      } else {
        const ind = workflowBlockCheckLists.findIndex((item) => item.id === id);
        workflowBlockCheckLists[ind] = resp.data;
        oWorkflowBlockCheckLists.workflowBlockCheckLists =
          workflowBlockCheckLists;
      }
      oWorkflowBlockCheckLists.workflowBlockCheckListsLength =
        workflowBlockCheckListsLength;

      dispatch({
        type: actions.GET_WORKFLOWBLOCK_CHECKLISTS,
        payload: {
          workflowBlockCheckLists:
            oWorkflowBlockCheckLists.workflowBlockCheckLists,
          workflowBlockCheckListsLength:
            oWorkflowBlockCheckLists.workflowBlockCheckListsLength,
        },
      });
      if (workflowBlockCheckListsOptions) {
        workflowBlockCheckListsOptions.setData(
          oWorkflowBlockCheckLists.workflowBlockCheckLists
        );
      }
      dispatch({
        type: actions.WORKFLOWBLOCK_CHECKLIST_FORM_FAIL,
        payload: null,
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = handleFormErrors(ex.response.data);
              break;
            case 500:
              message = messages.errorMessage + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.WORKFLOWBLOCK_CHECKLIST_FORM_FAIL,
        payload: message,
      });
    } finally {
      if (type === 2 && sameComp === false) {
        dispatch(
          enviarCorreo({
            workflow_id: workflow_id,
            bloque_id: bloque_id,
            tarea_id: tarea_id,
            tipo_mensaje: "Companero Guia - Notificacion acompanamiento",
          })
        );
      }
      dispatch({
        type: actions.SAVE_LOADING_WORKFLOWBLOCK_CHECKLIST,
        payload: false,
      });
    }
  };

export const deleteWorkflowBlockCheckList =
  (id, workflowBlockCheckListsOptions = null, type) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_WORKFLOWBLOCK_CHECKLISTS,
        payload: true,
      });
      await WorkFlowBlockCheckListServices.deleteWorkFlowBlockCheckLists(
        id,
        type
      );

      let oWorkflowBlockCheckLists = {
        workflowBlockCheckLists: [],
        workflowBlockCheckListsLength: 0,
      };

      const { workflowBlockCheckLists, workflowBlockCheckListsLength } =
        getState().workflowBlockCheckList;

      if (workflowBlockCheckListsOptions) {
        const ind = workflowBlockCheckListsOptions.data.findIndex(
          (item) => item.id === id
        );
        workflowBlockCheckListsOptions.data.splice(ind, 1);
        oWorkflowBlockCheckLists.workflowBlockCheckLists =
          workflowBlockCheckListsOptions.data;
      } else {
        const ind = workflowBlockCheckLists.findIndex((item) => item.id === id);
        workflowBlockCheckLists.splice(ind, 1);
        oWorkflowBlockCheckLists.workflowBlockCheckLists =
          workflowBlockCheckLists;
      }
      oWorkflowBlockCheckLists.workflowBlockCheckListsLength =
        workflowBlockCheckListsLength - 1;

      //const { workflowBlockCheckLists, workflowBlockCheckListsLength } = getState().workflowBlockCheckList;
      dispatch({
        type: actions.GET_WORKFLOWBLOCK_CHECKLISTS,
        payload: {
          workflowBlockCheckLists:
            oWorkflowBlockCheckLists.workflowBlockCheckLists,
          workflowBlockCheckListsLength:
            oWorkflowBlockCheckLists.workflowBlockCheckListsLength,
        },
      });
      if (workflowBlockCheckListsOptions) {
        workflowBlockCheckListsOptions.setData(
          oWorkflowBlockCheckLists.workflowBlockCheckLists
        );
      }
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 404:
              message = messages.notFound;
              break;
            case 500:
              message = messages.errorMessage + ex.message;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.WORKFLOWBLOCK_CHECKLIST_FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_WORKFLOWBLOCK_CHECKLISTS,
        payload: false,
      });
    }
  };

export const saveWorkFlowBlockCheckListPosition =
  (data, filters, setData = null, type) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_WORKFLOW_CHECKLIST_POSITION,
        payload: true,
      });
      await WorkFlowBlockCheckListServices.saveWorkFlowBlockCheckListPosition(
        data
      );

      dispatch({
        type: actions.WORKFLOWBLOCK_CHECKLIST_FAIL,
        payload: "",
      });

      const resp =
        await WorkFlowBlockCheckListServices.getWorkFlowBlockCheckLists(
          filters,
          type
        );

      dispatch({
        type: actions.GET_WORKFLOWBLOCK_CHECKLISTS,
        payload: {
          workflowBlockCheckLists: resp.data.data,
          workflowBlockCheckListsLength: resp.data.count,
        },
      });

      if (setData) {
        setData(resp.data.data);
      }

      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = "";
      if (axios.isAxiosError(ex)) {
        if (ex.response?.data) {
          if (ex.response?.status === 500) {
            message = messages.errorMessage;
          } else {
            message = ex.response.data.message;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.WORKFLOWBLOCK_CHECKLIST_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_WORKFLOW_CHECKLIST_POSITION,
        payload: false,
      });
    }
  };
